export default __webpack_public_path__ + "static/media/Rasheedat.e150fb95.jpg";